import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { interval, Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import moment from 'moment';
import { SendOtpDto } from 'src/app/Model/Shipping/send-otp-dto';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-otp-dialog',
  templateUrl: './otp-dialog.component.html',
  styleUrls: ['./otp-dialog.component.css']
})
export class OtpDialogComponent implements OnInit, OnDestroy{

  resendDisabled: boolean = false;
  resendTimeout: any;
  countdown: number = 0;
  countdownTwo: number = 0;
  countdownInterval: any;
  unsuccessfulAttempts: number = 0;
  buttonDisabled: boolean = true;
  disableTimeout: any;

  shipping: AllDeliveryDetailsDto = new AllDeliveryDetailsDto();
  randomString: string = "";
  showHideSendOtpDiv: boolean = true;
  invNo: string;
  verified: boolean = false;
  enterededOtp: string = 'XXXXXX';
  showError: boolean = false;
  showSucess: boolean = false;
  showResendOtp: boolean = false;
  errorLog: ErrorLog = new ErrorLog();

  isShaking: boolean = false;
  encryptedOtp: string = "";
  finalOTP: string = "";

  private shippingDetailSubscription: Subscription;
  private whatsAppOptInByMobileNoSubscription: Subscription;
  private whatsAppOTPByMobileNoSubscription: Subscription;
  private onCreateSetUpClickSubscription: Subscription;

  constructor(
    private dialogRef: MatDialogRef<OtpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private constant: Constant,
    public dialog: MatDialog,
    private apiFactory: APIFactoryEndPoints,
    private shippingManagerService: ShippingManagerService,
    public persistenceService: LocalStorageService,
    private toastService: ToastrService,
    private datePipe: DatePipe

  ) {
    dialogRef.disableClose = true;
    this.invNo = dialogData.shippingData;
    console.log(this.invNo);
  }

  ngOnInit(): void {
    this.getShippingDetailsInvNo();
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }

    if (this.disableTimeout) {
      clearTimeout(this.disableTimeout);
    }
  }

  getShippingDetailsInvNo() {
    this.shippingDetailSubscription = this.shippingManagerService.getShippingDetailsByInvNo(this.apiFactory.getDeliveryDetailsByInvNo, this.invNo).subscribe(data => {
      if (data.length > 0) {
        this.shipping = data[0];
        console.log(this.shipping.customerDto?.customerMobile);
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
    });
  }

  onEnterOtp(event: KeyboardEvent, nextId: string, index: number) {
    const value = event.target['value']; // Get the value of the input field
  
    // Check if a number was entered
    if (value && value.length === 1) {
      this.enterededOtp = this.enterededOtp.substring(0, index) + value + this.enterededOtp.substring(index + 1);
  
      // Store the final OTP when the last input is filled
      if (index === 5) {
        this.finalOTP = this.enterededOtp.replace(/X/g, ''); // Store the final OTP, removing 'X's
        console.log('Final OTP:', this.finalOTP); // Log for debugging
        this.updateSubmitButtonState(); // Update button state before focusing
        this.focusSubmitButton(); // Focus the submit button
      } else {
        // Move focus to the next input
        const nextInput = document.getElementById(nextId);
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  
    // Handle backspace
    if (event.key === 'Backspace') {
      this.enterededOtp = this.enterededOtp.substring(0, index) + 'X' + this.enterededOtp.substring(index + 1); // Reset the current index to 'X'
      if (index > 0) {
        const prevInput = document.getElementById(this.getPrevInputId(index));
        if (prevInput) {
          prevInput.focus(); // Move focus back to the previous input
        }
      }
    }
  
    // Update the submit button's disabled state
    this.updateSubmitButtonState();
  }
  
  // Helper method to focus the submit button
  focusSubmitButton() {
    setTimeout(() => {
      const submitButton = document.getElementById('submitBtn'); // Make sure to set the correct ID for the button
      if (submitButton) {
        submitButton.focus(); // Focus the submit button
      }
    }, 0); // Using setTimeout to ensure the DOM updates before focusing
  }
  
  // Update the submit button's disabled state
  updateSubmitButtonState() {
    const allFilled = this.enterededOtp.split('').every(char => char !== 'X'); // Check if all inputs are filled
    this.buttonDisabled = !allFilled; // Disable the button if any input is not filled
  }
  
  // Helper method to get the ID of the previous input
  getPrevInputId(index: number): string {
    const ids = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
    return ids[index - 1]; // Return the ID of the previous input
  }
  


  submitClick(): void {
    if (this.buttonDisabled) return;
    console.log(this.finalOTP);
    this.dialogRef.close(this.finalOTP)
    this.triggerShake();
  }

  triggerShake() {
    this.isShaking = true;
    setTimeout(() => {
      this.isShaking = false;
    }, 500);
  }

  disableButton() {
    this.buttonDisabled = true;

    this.countdownTwo = 120;

    this.countdownInterval = setInterval(() => {
      this.countdownTwo--;
      if (this.countdownTwo <= 0) {
        this.resendDisabled = false;
        clearInterval(this.countdownInterval);
      }
    }, 1000);

    // Set a timeout to re-enable the button after 2 minutes
    this.disableTimeout = setTimeout(() => {
      this.buttonDisabled = false;
      this.unsuccessfulAttempts = 0;
    }, 120000);
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Verify WhatsApp No";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;
  }

}
